import Vue from 'vue'
import './plugins/axios'
import axios from 'axios';
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/iview.js'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  axios,
  render: h => h(App),
  mounted() {
    // 测试
    // axios.defaults.baseURL = 'https://hm.strongunion.com.cn/platformwebserver/'
    // 生产
    axios.defaults.baseURL = 'https://www.up-zy.com/platformwebserver/'
    // 生产 8080
    // axios.defaults.baseURL = 'http://www.up-zy.com:8080/platformwebserver/'
  },
}).$mount('#app')
